var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.875C15.9017 7.875 17.5817 8.33 18.9467 8.925C20.2067 9.485 21 10.745 21 12.11V14H7V12.1217C7 10.745 7.79333 9.485 9.05333 8.93667C10.4183 8.33 12.0983 7.875 14 7.875ZM4.66667 8.16667C5.95 8.16667 7 7.11667 7 5.83333C7 4.55 5.95 3.5 4.66667 3.5C3.38333 3.5 2.33333 4.55 2.33333 5.83333C2.33333 7.11667 3.38333 8.16667 4.66667 8.16667ZM5.985 9.45C5.55333 9.38 5.12167 9.33333 4.66667 9.33333C3.51167 9.33333 2.415 9.57833 1.42333 10.01C0.56 10.3833 0 11.2233 0 12.1683V14H5.25V12.1217C5.25 11.1533 5.51833 10.2433 5.985 9.45ZM23.3333 8.16667C24.6167 8.16667 25.6667 7.11667 25.6667 5.83333C25.6667 4.55 24.6167 3.5 23.3333 3.5C22.05 3.5 21 4.55 21 5.83333C21 7.11667 22.05 8.16667 23.3333 8.16667ZM28 12.1683C28 11.2233 27.44 10.3833 26.5767 10.01C25.585 9.57833 24.4883 9.33333 23.3333 9.33333C22.8783 9.33333 22.4467 9.38 22.015 9.45C22.4817 10.2433 22.75 11.1533 22.75 12.1217V14H28V12.1683ZM14 0C15.9367 0 17.5 1.56333 17.5 3.5C17.5 5.43667 15.9367 7 14 7C12.0633 7 10.5 5.43667 10.5 3.5C10.5 1.56333 12.0633 0 14 0Z",
    fill: "#FDB71A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.d8a7cd9fe990ab229ed1c44f804421f2.svg";
export { ForwardRef as ReactComponent };